import script from "./Vehicles.vue?vue&type=script&setup=true&lang=js"
export * from "./Vehicles.vue?vue&type=script&setup=true&lang=js"

import "./Vehicles.vue?vue&type=style&index=0&id=20d8e424&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d8e424"]])

export default __exports__